export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const INFO_REQUEST = 'INFO_REQUEST';
export const INFO_SUCCESS = 'INFO_SUCCESS';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHECK_NICKNAME_REQUEST = 'CHECK_NICKNAME_REQUEST';
export const CHECK_EMAIL_REQUEST = 'CHECK_EMAIL_REQUEST';
export const LOST_PASSWORD_REQUEST = 'LOST_PASSWORD_REQUEST';
export const VERIFY_LOST_PASSWORD_REQUEST = 'VERIFY_LOST_PASSWORD_REQUEST';
export const CHANGE_LOST_PASSWORD_REQUEST = 'CHANGE_LOST_PASSWORD_REQUEST';
export const RESEND_ACTIVATION_EMAIL_REQUEST = 'RESEND_ACTIVATION_EMAIL_REQUEST';
export const ACTIVATE_EMAIL_REQUEST = 'ACTIVATE_EMAIL_REQUEST';
export const ACTIVATE_EMAIL_SUCCESS = 'ACTIVATE_EMAIL_SUCCESS';
export const GET_USER_DETAIL_REQUEST = 'GET_USER_DETAIL_REQUEST';
export const SET_USER_TEAM = 'SET_USER_TEAM';
export const LISTING_USERS_REQUEST = 'LISTING_USERS_REQUEST';
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
